import {ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { formatText, formatYear } from 'src/app/shared/commen-function-file';
import { SharedService } from 'src/app/service/shared/shared.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { ColDef, ExcelExportParams,GridReadyEvent, ISetFilterParams, themeQuartz, ValueFormatterParams } from 'ag-grid-community';
import { CommentDialogComponent } from 'src/app/shared/comment-dialog/comment-dialog.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-asset-error-log',
  templateUrl: './asset-error-log.component.html',
  styleUrls: ['./asset-error-log.component.scss'],
})
export class AssetErrorLogComponent implements OnInit {

  buttonColorName: any
  updateLogsData: any = [];
  deleteLogsData: any = [];
  selectedTypeTabIndex: any;
  selectedTypeTabName: any = 'Deleted Asset';
  EmployeeSummaryData: any;
  loggedInUserCompanyID: any;
  loggedInUserId: any;
  loggedInCompanyFiscalyear: any | null;
  pmsYears: any = []
  selectedYearForCompetency: any = null;
  fromYear: any;
  toYear: any;
  selectedYear: any;
  searchTaskString: string = '';

  constructor(public sharedService: SharedService, private dialog: MatDialog,private cdRef: ChangeDetectorRef, public router: Router, private httpService: HttpService, private config: Config, private encryptionService: EncryptionService) { }

  ngOnInit() {

    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');

    this.getpmsyearlist();
    this.getEmployee();


    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');

    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }

  }
  formatedataVariable = formatText;
  previousPage() {
    this.router.navigate(['/home/hrportal/asset-management']);
  }
  onClickVariablePaySetup(event: any) { }
  nextPage() {

  }
  onClickBreadcrumExpence() {
    this.router.navigate(['/home/hrportal/asset-management']);

  }

  tableDataDetails: any = [];
  onSortAssending(sortKey: any): void {
    this.updateLogsData.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
      if (a[sortKey] < b[sortKey]) return -1;
      if (a[sortKey] > b[sortKey]) return 1;
      return 0;
    });
  }
  onSortDesending(sortKey: any): void {
    this.updateLogsData.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
      if (a[sortKey] > b[sortKey]) return -1;
      if (a[sortKey] < b[sortKey]) return 1;
      return 0;
    });
  }



  onSortAssendingDeleted(sortKey:any){
    this.deleteLogsData.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
      if (a[sortKey] < b[sortKey]) return -1;
      if (a[sortKey] > b[sortKey]) return 1;
      return 0;
    });
  }



  onSortDesendingDeleted(sortKey:any){
    this.deleteLogsData.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
      if (a[sortKey] > b[sortKey]) return -1;
      if (a[sortKey] < b[sortKey]) return 1;
      return 0;
    });
  }

  tabTypeChanged(event: MatTabChangeEvent) {
    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index;

    this.selectedYearForCompetency = this.selectedYear;

  this.viewReimbursementByYear(this.selectedYearForCompetency);


  }



  // taskColumnHeaderInfo = [
  //   { label: 'Field', isMandatory: false, sortingName: 'fieldName' },
  //   { label: 'Old Value', isMandatory: false, sortingName: 'oldValue' },
  //   { label: 'New Value', isMandatory: false, sortingName: 'newValue' },
  //   { label: 'Changed By', isMandatory: false, sortingName: 'createdAt' },
  //   { label: 'Changed On', isMandatory: false, sortingName: 'updatedAt' }
  // ];

  taskColumnHeaderInfo = [
    { headerName: 'Field', isMandatory: true, minWidth: 230,filter: 'agSetColumnFilter', field: 'fieldName' },
  { headerName: 'Old Value', isMandatory: true, minWidth: 230,filter: 'agSetColumnFilter', field: 'oldValue' },
  { headerName: 'New Value', isMandatory: true, minWidth: 230,filter: 'agSetColumnFilter', field: 'newValue' },
  { headerName: 'Changed By', isMandatory: true, minWidth: 230,filter: 'agDateColumnFilter', field: 'changedByUserName' },
  { headerName: 'Changed On', isMandatory: true, minWidth: 230,filter: 'agDateColumnFilter', field: 'createdAt', cellRenderer: (params: any) => this.dateRenderer(params),
      comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),filterParams: {
        filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
        suppressAndOrCondition: true,  // ✅ AND/OR hide
        maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
      } }
  ];

  // taskDeletedHeaderInfo = [
  //   { label: 'Asset Department Name', isMandatory: true, sortingName: 'assetDepartmentName' },
  //   { label: 'Delete Date', isMandatory: true, sortingName: 'createdAt' },, 
  //   { label: 'Employee Name', isMandatory: true, sortingName: 'employeeName' },
  //   { label: 'Fiscal Year', isMandatory: true, sortingName: 'year' },
  //   { label: 'Year', isMandatory: true, sortingName: 'year' },
  //   { label: 'Asset Name', isMandatory: true, sortingName: 'assetName' },
  //   { label: 'Bands', isMandatory: true, sortingName: 'bands' },
  //   { label: 'Authority Name', isMandatory: true, sortingName: 'authorityName' },
  //   { label: 'Authority Department', isMandatory: true, sortingName: 'authorityDepartment' },
  // ];
   taskDeletedHeaderInfo = [
  { headerName: 'Asset Department Name', isMandatory: true, minWidth: 230,filter: 'agSetColumnFilter', field: 'authorityDepartment' },
  { headerName: 'Delete Date', isMandatory: true, minWidth: 230,filter: 'agDateColumnFilter', field: 'createdAt',  cellRenderer: (params: any) => this.dateRenderer(params),
      comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),filterParams: {
        filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
        suppressAndOrCondition: true,  // ✅ AND/OR hide
        maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
      } },
  { headerName: 'Employee Name', isMandatory: true, minWidth: 230,filter: 'agSetColumnFilter', field: 'authorityName' },
  // { headerName: 'Fiscal Year', isMandatory: true, minWidth: 230,filter: 'agSetColumnFilter', field: 'year' },
  {
    headerName: 'Fiscal Year',
    isMandatory: true,
    minWidth: 230,
    filter: 'agSetColumnFilter',
    field: 'year',
    valueFormatter: (params: any) => {
      const val = params.value;
      if (!val) return '';

      const parts = val.split('-');

      // If only one year → return "2025"
      if (parts.length === 1) {
        return parts[0];
      }

      // If two years and both same → return "2025"
      if (parts[0] === parts[1]) {
        return parts[0];
      }

      // Otherwise → return "2025-2026"
      return `${parts[0]}-${parts[1]}`;
    }
  },
  // { headerName: 'Year', isMandatory: true, minWidth: 230,filter: 'agSetColumnFilter', field: 'year' },
  {
    headerName: 'Year',
    isMandatory: true,
    minWidth: 230,
    filter: 'agSetColumnFilter',
    field: 'year',
    valueFormatter: (params: any) => {
      const val = params.value;
      if (!val) return '';

      const parts = val.split('-');

      // If only one year → return "2025"
      if (parts.length === 1) {
        return parts[0];
      }

      // If two years and both same → return "2025"
      if (parts[0] === parts[1]) {
        return parts[0];
      }

      // Otherwise → return "2025-2026"
      return `${parts[0]}-${parts[1]}`;
    }
  },
  { headerName: 'Asset Name', isMandatory: true, minWidth: 230,filter: 'agSetColumnFilter', field: 'assetName' },
  { headerName: 'Bands', isMandatory: true, minWidth: 230,filter: 'agSetColumnFilter', field: 'bands' },
  { headerName: 'Authority Name', isMandatory: true, minWidth: 230,filter: 'agSetColumnFilter', field: 'authorityName' },
  { headerName: 'Authority Department', isMandatory: true, minWidth: 230,filter: 'agSetColumnFilter', field: 'authorityDepartment' },
 ];
 formatFiscalYear(value: string): string {
  if (!value) return '';

  const parts = value.split('-');

  if (parts.length === 1) return parts[0];

  if (parts[0] === parts[1]) return parts[0];

  return `${parts[0]}-${parts[1]}`;
}

 
  apiYear: any;
  // getpmsyearlist() {
  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = [];

  //     data?.data?.yearRanges?.forEach((ele: any) => {
  //       var test = ele.split('_');
  //       let obj = {
  //         year: test[0] + '-' + test[1]
  //       };

  //       // Get current year
  //       const currentYear = new Date().getFullYear();

  //       // Ensure only past and current years are included
  //       var yearParts = obj.year.split('-');
  //       let fromYear = parseInt(yearParts[0]);
  //       let toYear = parseInt(yearParts[1]);

  //       // Add to pmsYears only if it's not a future year
  //       if (toYear <= currentYear) {
  //         this.pmsYears.push(obj);
  //       }
  //     });

  //     this.pmsYears?.forEach((ele: any) => {
  //       const currentYear = new Date().getFullYear();
  //       let yearValue = '';

  //       //  if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
  //       //    yearValue = `${currentYear}-${currentYear}`;
  //       //  } else {
  //       //    yearValue = `${currentYear}-${currentYear + 1}`;
  //       //  }
  //       if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
  //         yearValue = `${currentYear}-${currentYear}`; // Calendar year
  //       } else if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
  //         if (new Date().getMonth() < 3) {
  //           // If it's Jan, Feb, or Mar, we're in the previous fiscal year
  //           yearValue = `${currentYear - 1}-${currentYear}`;
  //         } else {
  //           // From Apr onwards, it's the current fiscal year
  //           yearValue = `${currentYear}-${currentYear + 1}`;
  //         }
  //       }
       
  //       if (ele?.year == yearValue) {
  //         this.selectedYearForCompetency = ele?.year;
  //         this.apiYear = ele.year;

  //         var test = ele?.year?.split('-');
  //         this.fromYear = test[0];
  //         this.toYear = test[1];
  //       }
      
  //     });


  //   });

  // }
   // --------------------------------AG GRID CODE---------------------------------------------------------
    gridApi: any;
    paginationPageSizeSelector = [5, 10, 20,50,100,200,500,1000];
    pagination = true;
    paginationPageSize = 10;
    detailRowAutoHeight = true;
  
    defaultColDef: ColDef = {
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
      sortable: true,
      floatingFilter: false,  // ✅ small filter box under header
    };
    
    gridOptions: any = {
      defaultColDef: {
        resizable: true,
        sortable: true,
        filter: true,
        floatingFilter: true,
        minWidth: 80,
    
        // ✅ add this
        cellClass: (p: any) => (p.node.rowIndex % 2 === 0 ? 'cell-even' : 'cell-odd')
      },
      context: { componentParent: this },
      rowSelection: 'single',
      localeText: {
        noRowsToShow: 'No Data Found'  // default text ko replace karna hai 'No Rows To Show' to 'No Data Found'
      }
    };
  
    openCommentModal(text: string,commentType:any) {
      this.dialog.open(CommentDialogComponent, {
        width: '600px',
        data: { 
          text: text,
          commentType: commentType
        }
      });
    
    }
  
    onGridReady(params: GridReadyEvent) {
      this.gridApi = params.api;
      params.api.sizeColumnsToFit();
      console.log(params)
    }
    formatStatus(value: any): string {
      if (!value || typeof value !== 'string') {
        return 'N/A'; // fallback agar value string na ho
      }
  
      // Camel Case → Title Case
      return value
        .toLowerCase()
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    }
  
    formatDate(value: any): string {
      if (!value) return 'N/A';
    
      const date = new Date(value);
      if (isNaN(date.getTime())) return 'Invalid Date';
    
      // dd-MM-yyyy format
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
    
      return `${day}-${month}-${year}`;
    }
  
    
    // Helper function to convert any date string into dd-MM-yyyy
    formatDateOnly(dateStr: string | null): string | null {
      if (!dateStr) return null;
    
      let datePart = dateStr;
      if (dateStr.includes('T')) {
        datePart = dateStr.split('T')[0];  
      }
    
      const [y, m, d] = datePart.split('-').map(Number);
      if (!y || !m || !d) return null;
    
      // Date object 
      const date = new Date(y, m - 1, d);
    
      // Format dd-MM-yyyy
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    }
    
    // ✅ Global search function
    onFilterTextBoxChanged(value: string = '') {
      if (!this.gridApi) return;
    
      // v31+ way:
      this.gridApi.setGridOption('quickFilterText', value ?? '');
     
    }
  
    onBtExport(strMsg:any) {
    const params: ExcelExportParams = {
      fileName: strMsg+'_' + new Date().toISOString().slice(0, 10) + '.xlsx',
      sheetName: strMsg,
      exportAsExcelTable: {
        showRowStripes: true,
        name: strMsg
      },
      processCellCallback: (cell) => {
        const header = cell.column.getColDef().headerName;
        const value = cell.value;
 
        // 1. Date Formatting (for specific headers)
        const dateColumns = ['createdAt', 'createdAt']; // <- field names ya headerName use karo
 
        if (dateColumns.includes(cell.column.getColId()) && cell.value) {
          const date = new Date(cell.value);
          if (!isNaN(date.getTime())) {
            return (
              ('0' + date.getDate()).slice(-2) +
              '-' +
              ('0' + (date.getMonth() + 1)).slice(-2) +
              '-' +
              date.getFullYear()
            );
          }
        }
 
        // 2. Status Formatting (make it human readable)
        if (header === 'Employee Status' || header === 'Authority Department Comment' && value) {
          return value
            .toString()
            .toLowerCase()
            .replace(/_/g, ' ') // replace underscores with space
            .replace(/\b\w/g, (char:any) => char.toUpperCase()); // capitalize each word
        }
 
        return value;
      }
    };
 
    this.gridApi.exportDataAsExcel(params);
  }
    
    approvalRenderer(params: any) {
      if (!params.value) return '';
          const status = params.value.toUpperCase();
        
          let color = '';
          if (status === 'APPROVED') {
            color = '#4caf50'; // green
          } else if (status === 'REJECTED') {
            color = '#f44336'; // red
          } else if (status === 'PENDING') {
            color = '#ff9800'; // orange
          }
        
          return `
            <span style="
              border: 1px solid ${color};
              color: ${color};
              padding: 4px 10px;
              border-radius: 12px;
              font-size: 12px;
              font-weight: 500;
              display: inline-block;
              line-height: 20px;
              white-space: nowrap;
            ">
          ${status.charAt(0) + status.slice(1).toLowerCase()}
        </span>
      `;
    }
  
    statusFormatter(params: any): string {
      if (!params.value) return '';
    
      const valueUpper = params.value.toUpperCase();
    
      // 🔹 Status → Color map
      const statusColors: Record<string, string> = {
        'APPROVED_BY_FINANCE_BUT_NOT_PAID': '#4caf50', // green
        'APPROVED_BY_MANAGER_SENT_TO_FINANCE': '#4caf50',
        'APPROVED_BY_MANAGER_REJECTED_BY_FINANCE': '#f44336', // red
        'REJECTED_BY_MANAGER': '#f44336',
        'PENDING_WITH_MANAGER': '#ff9800' // orange
      };
    
      // 🔹 Default color = grey
      const color =
        Object.keys(statusColors).find(key => valueUpper.includes(key))
          ? statusColors[
              Object.keys(statusColors).find(key => valueUpper.includes(key))!
            ]
          : '#999';
    
      // 🔹 Convert to Title Case
      const formattedText = params.value
        .toLowerCase()
        .split('_')
        .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    
      return `
        <span style="
          border: 1px solid ${color};
          color: ${color};
          padding: 4px 10px;
          border-radius: 12px;
          font-size: 12px;
          font-weight: 500;
          display: inline-block;
          white-space: normal;
          word-wrap: break-word;
          line-height: 1.4em;
          animation: fadeInScale 0.3s ease-in-out;
          max-width: 100%;
        ">
          ${formattedText}
        </span>
      `;
    }
    
    dateRenderer(params: any) {
      if (!params.value) return '';
      const date = new Date(params.value);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    }
  
    dateComparator(valueA: string, valueB: string) {
      const parseDate = (value: string) => {
        if (!value) return null;
        // Agar backend se yyyy-mm-dd aa raha hai:
        if (value.includes('-') && value.indexOf('-') === 4) {
          return new Date(value).getTime();
        }
        // Agar already dd-mm-yyyy format hai:
        const [day, month, year] = value.split('-').map(Number);
        return new Date(year, month - 1, day).getTime();
      };
  
      const dateA = parseDate(valueA);
      const dateB = parseDate(valueB);
  
      if (dateA === dateB) return 0;
      if (dateA == null) return -1;
      if (dateB == null) return 1;
      return dateA - dateB;
    }
  
    openFile(fileUrl: string) {
      window.open(fileUrl, '_blank');
    }
    downloadRenderer = (params: any) => {
      
      const fileUrl = `${this.config.downloadFile}${params.value}`;
      if (!params.value) return '';
      const img = document.createElement('img');
      img.src = 'assets/icon/yellowdownload.png'; // replace with your icon path
      img.alt = 'download';
      img.style.width = '18px';
      img.style.height = '18px';
      img.style.cursor = 'pointer';
      img.title = params.value;
      img.addEventListener('click', (e) => {
        e.stopPropagation();
        // open file in new tab
        window.open(fileUrl, '_blank');
      });
      return img;
    }
  
    downloadDialogRenderer(fileName: string): string {
      if (!fileName) return '';
      return `${this.config.downloadFile}${fileName}`;
    }
    selectedRow: any;
    isDetailsOpen = false;
    onRowClicked(event: any) {
      this.selectedRow = event.data;
      this.isDetailsOpen = true;
    }
    closeDetails() {
      this.isDetailsOpen = false;
    }
  
   isClicked = false;
   
  
    resetGrid() {
      this.isClicked = false; // Trigger animation
    
      if (this.gridApi) {
        // ✅ Reset filters & sorting
        this.gridApi.setFilterModel(null);
        // this.gridApi.setSortModel(null);
        this.gridApi.deselectAll();
    
        // ✅ Reset quick filter (search box)
        this.searchTaskString = '';
        this.gridApi.setGridOption('quickFilterText', ''); // Clears quick filter text
    
        // ✅ Reset pagination
        this.paginationPageSize = 10;
        this.gridApi.setGridOption('paginationPageSize', this.paginationPageSize);
        this.gridApi.paginationGoToFirstPage();
    
        // ✅ Force refresh so UI input also clears
        this.gridApi.refreshCells();
        this.gridApi.resetColumnState();         // ✅ Reset columns
      }
    }

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      // this.pmsYears = formatYearRanges(data?.data?.yearRanges);
      this.pmsYears = formatYear(data?.data?.yearRanges, this.loggedInCompanyFiscalyear);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
      this.setSelectedYear(yearValue);

    });
  }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYear = this.selectedYearForCompetency = selectedYearObj.year;

      var test = this.selectedYearForCompetency?.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      // this.defaultCallFunctionsList();
      [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
    }
  }



  //viewReimbursementByYear
  viewReimbursementByYear(year: any) {

    if (this.selectedTypeTabName == 'Updated Asset') {

      this.viewLogsDetails();
    } else {
      this.viewDeleteLogsDetails();
    }
  }

  getEmployee() {

    const request = {
      "companyId": this.loggedInUserCompanyID,
      "userId": this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getTeamOfManager, request).subscribe((data: any) => {
      this.EmployeeSummaryData = data.data;
      this.viewLogsDetails();
      this.viewDeleteLogsDetails();
    })
  }

  viewLogsDetails() {
    this.httpService.callGetService(`${this.config.viewLogsForAssetUpdate}/${this.loggedInUserCompanyID}/${this.selectedYearForCompetency}`)
      .subscribe((result: any) => {
        this.updateLogsData = result.data;

        this.updateLogsData.forEach((ele: any) => {
          // Ensure EmployeeSummaryData is defined and is an array
          if (!this.EmployeeSummaryData || !Array.isArray(this.EmployeeSummaryData)) {
            console.error('EmployeeSummaryData is not defined or not an array');
            return;
          }

          // Get the name of the HR/Admin who changed the log
          const matchingHRAdmin = this.EmployeeSummaryData
            .filter((employee: { id: any }) => employee.id === ele.changedByUserId)
            .map((employee: { firstName: string; lastName: string }) => `${employee.firstName.trim()} ${employee.lastName.trim()}`);

          ele.changedByUserName = matchingHRAdmin.length > 0 ? matchingHRAdmin[0] : '';

          if (ele.fieldName === 'financeAccessEmployeeIds') {
            // Parse the oldValue safely
            let oldValueIds: any;
            try {
              oldValueIds = JSON.parse(ele.oldValue);
            } catch (error) {
              console.error('Invalid JSON in oldValue:', ele.oldValue, error);
              return;
            }

            // Match IDs and extract names for oldValue
            const matchingEmployees = this.EmployeeSummaryData
              .filter((employee: { id: any }) => oldValueIds.includes(employee.id))
              .map((employee: { firstName: string; lastName: string }) => `${employee.firstName.trim()} ${employee.lastName.trim()}`);

            ele.oldValue = matchingEmployees;

            // Parse the newValue safely
            let newValueIds: any;
            try {
              newValueIds = JSON.parse(ele.newValue);
            } catch (error) {
              console.error('Invalid JSON in newValue:', ele.newValue, error);
              return;
            }

            // Match IDs and extract names for newValue
            const matchingNewEmployees = this.EmployeeSummaryData
              .filter((employee: { id: any }) => newValueIds.includes(employee.id))
              .map((employee: { firstName: string; lastName: string }) => `${employee.firstName.trim()} ${employee.lastName.trim()}`);

            ele.newValue = matchingNewEmployees;
          }
        });

       
      });
  }



  //Delete Log
  viewDeleteLogsDetails() {
    this.httpService.callGetService(`${this.config.viewLogsForAssetDeleted}/${this.loggedInUserCompanyID}/${this.selectedYearForCompetency}`)
      .subscribe((result: any) => {
        const authorities = result.data.deletedAuthorities || [];
        const assets = result.data.deletedAssets || [];
  
        this.deleteLogsData = assets.map((asset: { userId: any; }) => {
          const matchingAuthority = authorities.find((auth: { userId: any; }) => auth.userId === asset.userId);
          return {
            ...asset,
            assetDepartmentName: matchingAuthority?.assetDepartmentName || '',
            employeeName: matchingAuthority?.employeeName || '',
          };
        });
        this.cdRef.detectChanges();
        console.log('Final deleteLogsData:', this.deleteLogsData); // 
      });
  }
  
}
